module.exports = __webpack_public_path__ + "img/header-mobile.6e979190.png";